'use strict';

class RecipientPicker {
  constructor($scope, $timeout, $filter, recipientService, commonService, validationService, StoreService, labelService) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$filter = $filter;
    this.recipientService = recipientService;
    this.commonService = commonService;
    this.validationService = validationService;
    this.availableLabels = new StoreService();
    this.selectedLabels = new StoreService();
    this.labelService = labelService;
  }

  $onInit() {
    this.newLabel = null;

    this.locked = this.locked || false;
    this.allownew = this.allownew || 'y';
    this.showBrreg = this.showBrreg || false;
    this.lang = this.lang || 'no';

    this.limit = 200;
    this.total = 0;
    this.state = false;

    this.recipients = [];
    this.recipient = {};

    this.testOrgNo = {
      message: null,
      valid: true
    };

    this.discount = '';
    this.creditDays = null;
    this.yourReference = null;
    this.lost = false;
    this.currency = 'NOK';

    this.lastSelected = -1;
    this.lastOffset = 0;
    this.itemHeight = 30.55;

    this.loadCountries();

    this.getLabels();

    this.$scope.$on('selectedBrreg', (e, val) => {
      if (val) {
        this.recipient.name = val.name;
        this.recipient.contact.address = val.address;
        this.recipient.organisationNumber = val.orgNo;
        this.recipient.icd = '9908';

        this.broadcast();
      }
    });

    // search
    this.$scope.$watch('$ctrl.recipient.name', (val, old) => {
      if (val && val !== old) {
        this.search(val);
      } else {
        this.recipients = [];
      }
    });

    if (typeof this.data !== 'undefined') {
      // load predefined data
      this.$scope.$watch('$ctrl.data', (val) => {
        if (typeof val !== 'undefined' && val !== null) {
          this.locked = true;
          this.state = true;

          this.recipient = {
            number: val.number,
            name: val.name,
            customerNumber: val.customerNumber,
            contact: {
              address: val.address,
              email: val.email,
              mobile: val.mobile
            },
            organisationNumber: val.organisationNumber,
            icd: val.icd,
            organisation: {
              icd: val.icd
            }
          };
        }
      });
    } else {
      // or load from recipients
      $('#recipientSearch').trigger('focus');

      this.$scope.$watch('$ctrl.number', (val) => {
        if (typeof val !== 'undefined' && val !== null) {
          this.load(val);
        }
      });
    }
  }

  getLabels() {
    this.labelService.list()
      .then((resp) => {
        if (resp.data && resp.status !== 204) {
          resp.data.map((label) => {
            this.availableLabels.add(label);
          });
        }
      });
  }

  selectLabel(label) {
    if (label && label.number) {
      this.availableLabels.remove(label);
      this.selectedLabels.add(label);

      this.prepareLabelsOnRecipient();
    }
  }

  /**
   * Creates a new label and assign the recipient to it
   */
  addLabel() {
    if (this.newLabel) {
      this.labelService.create(this.newLabel)
        .then((resp) => {
          let number = resp.headers('Location').split('/')[5];
          let numberInt = parseInt(number, 10);

          this.selectedLabels.add({
            number: numberInt,
            name: this.newLabel
          });

          this.newLabel = null;
          this.prepareLabelsOnRecipient();
        });
    }
  }

  /**
   * Remove a label from the recipient
   *
   * @param {Object} label Label to remove
   */
  deselectLabel(label) {
    if (label && label.number) {
      this.availableLabels.add(label);
      this.selectedLabels.remove(label);
      this.prepareLabelsOnRecipient();
    }
  }

  prepareLabelsOnRecipient() {
    let labels = this.selectedLabels.get();
    let labelNumbers = [];

    this.recipient.labels = [];

    if (labels) {
      labels.forEach((item) => {
        labelNumbers.push(item.number);
        this.recipient.labels = labelNumbers;
      });
      this.broadcast();
    }
  }
  /**
   * Search recipient by name or customerNumber
   *
   * @param {String} q Query to search for
   */
  search(q) {
    let promise;

    if (q !== null && q !== '') {
      this.$timeout.cancel(promise);

      promise = this.$timeout(() => {
        this.recipientService.search(q, this.limit)
          .then((resp) => {
            this.recipients = resp.data.recipients.map((recipient) => {
              return {
                number: recipient.number,
                name: recipient.name,
                customerNumber: recipient.recipientNo
              };
            });
            this.total = resp.data.total;
          });
      }, 400);
    } else {
      this.recipients = [];
    }
  }

  /**
   * Load countries
   */
  loadCountries() {
    this.countries = ['NORGE'];
    this.commonService.getCountries()
      .then((resp) => {
        this.countries = resp;
      });
  }

  createNew(name) {
    // create new
    this.recipient = {
      name: name,
      contact: {
        address: {
          country: 'NORGE'
        },
        mobile: null
      },
      organisationNumber: null,
      icd: '9908',
      organisation: {
        icd: '9908'
      }
    };
    this.state = true;
    this.suggestCustomerNumber();
  }

  /**
   * Bind key actions
   *
   * @param {Object} $event Event triggerd on input
   */
  actions($event) {
    const clone = angular.copy(this.recipient);

    if ($event.keyCode === 13) {
      // enter
      if (this.recipients.length) {
        if (this.lastSelected === -1) {
          this.lastSelected = 1;
        }

        if (this.recipients[this.lastSelected] && this.recipients[this.lastSelected].number) {
          this.load(this.recipients[this.lastSelected].number);
        }
      } else {
        this.createNew(clone.name);
      }
    } else if ($event.keyCode === 38) {
      // up arrow
      if (this.lastSelected > 0) {
        // remove selected
        this.recipients.forEach((item) => {
          item.selected = false;
        });

        // select next
        this.recipients[this.lastSelected - 1].selected = true;

        // auto scroll container
        if (this.lastOffset >= this.itemHeight) {
          this.lastOffset = this.lastOffset - this.itemHeight;
        }

        $('.scroll-content').scrollTop(this.lastOffset - this.itemHeight);

        // prepare for next selection
        this.lastSelected--;
      }
    } else if ($event.keyCode === 40) {
      // down arrow
      if (this.lastSelected < this.recipients.length - 1) {
        // remove selected
        this.recipients.forEach((item) => {
          item.selected = false;
        });

        // select next
        this.recipients[this.lastSelected + 1].selected = true;

        // auto scroll container
        if (this.lastOffset > 200) {
          $('.scroll-content').scrollTop(this.lastOffset);
        }

        this.lastOffset = this.lastOffset + this.itemHeight;

        // prepare for next selection
        this.lastSelected++;
      }
    }
  }

  /**
   * Load a recipient by number
   *
   * @param {Integer} number Recipient number
   */
  load(number) {
    this.recipientService.get(number)
      .then((resp) => {
        this.state = true;
        this.recipients = [];

        this.recipient = resp.data;
        this.recipient.organisationNumber = resp.data.organisation.number;
        this.recipient.icd = resp.data.organisation.icd;

        this.discount = resp.data.settings.discount;
        this.creditDays = resp.data.settings.creditDays;
        this.lost = resp.data.settings.lost;
        this.yourReference = resp.data.yourReference;

        // reset focus
        this.lastSelected = -1;
        this.lastOffset = 0;

        this.broadcast();
      });
  }

  /**
   * Reset widget state
   */
  reset() {
    this.state = false;

    this.recipients = [];
    this.recipient = null;

    this.testOrgNo = {
      message: null,
      valid: true
    };

    this.discount = '';
    this.creditDays = null;
    this.lost = null;
    this.currency = 'NOK';
    this.yourReference = null;
    this.selectedRecipient = {};

    // reset focus
    this.lastSelected = -1;
    this.lastOffset = 0;

    this.broadcast();
  }

  /**
   * Suggest the next available customer number
   */
  suggestCustomerNumber() {
    this.recipientService.suggestCustomerNumber()
      .then((resp) => {
        this.recipient.customerNumber = resp.data.customerNumber;
      });
  }

  /**
   * Get city by zip code
   */
  getCityByZip() {
    if (this.recipient && this.recipient.contact.address.zip && this.recipient.contact.address.country === 'NORGE') {
      if (this.recipient.contact.address.zip.length === 4) {
        this.commonService.getCityByPostCode(this.recipient.contact.address.zip)
          .then((resp) => {
            this.recipient.contact.address.city = resp.data.city ? resp.data.city : 'OLSO';
          });
      }
    }
  }

  /**
   * Populate parent with the recipient data
   */
  broadcast() {
    if (!this.recipient) {
      this.selectedRecipient = null;
    } else {
      this.selectedRecipient = {
        number: this.recipient.number,
        customerNumber: this.recipient.customerNumber,
        name: this.recipient.name,
        address: this.recipient.contact.address,
        email: this.recipient.contact.email,
        mobile: this.recipient.contact.mobile,
        organisationNumber: this.testOrgNo.valid ? this.recipient.organisationNumber : null,
        icd: this.recipient.organisation.icd,
        yourReference: this.yourReference,
        discount: this.recipient && this.recipient.settings ? this.recipient.settings.discount : 0,
        currency: this.recipient && this.recipient.settings ? this.recipient.settings.currency : null,
        creditDays: this.creditDays,
        labels: this.recipient.labels,
        vatNumber: this.recipient.vatNumber
      };
    }

    // send data to other directives
    this.$scope.$emit('selectedRecipient', this.selectedRecipient);
  }

  /**
   * Get label for given language
   *
   * @param {String} name Property for label
   * @returns {String}
   */
  getLabel(name) {
    const i18n = {
      no: {
        HEADER: 'Mottager',
        NUMBER: 'Kundenummer',
        NAME: 'Navn',
        ORGNO: 'Organisasjonsnummer',
        ADDRESS: 'Adresse',
        ZIP: 'Postnummer',
        CITY: 'Poststed',
        COUNTRY: 'Land',
        EMAIL: 'E-postadresse',
        MOBILE: 'Mobilnummer'
      },
      en: {
        HEADER: 'Recipient',
        NUMBER: 'Recipient number',
        NAME: 'Name',
        ORGNO: 'Organisation number',
        ADDRESS: 'Address',
        ZIP: 'Zip',
        CITY: 'City',
        COUNTRY: 'Country',
        EMAIL: 'E-mail',
        MOBILE: 'Mobile'
      }
    };

    return i18n[this.lang][name];
  }
}

RecipientPicker.$inject = ['$scope', '$timeout', '$filter', 'recipientService', 'commonService', 'validationService', 'StoreService', 'labelService'];

const recipientPicker = {
  bindings: {
    number: '<',
    data: '<',
    allownew: '<',
    lang: '<',
    locked: '<',
    showBrreg: '<'
  },
  controller: RecipientPicker,
  template: `
    <div class="alert-box warning" ng-show="$ctrl.lost">
      <i class="fa fa-warning"></i> Tidligere regninger til denne kunden er merket som tapt. Det anbefales å kreve forhåndsbetaling
    </div>

    <fieldset ng-class="{ recipientLost: $ctrl.lost }">

      <div class="row">
        <div class="large-10 columns">
          <h3 class="subheader">{{ $ctrl.getLabel('HEADER') }}</h3>
        </div>
        <div class="large-2 columns right-align" ng-hide="$ctrl.locked">
          <b ng-click="$ctrl.reset()" ng-show="$ctrl.state" class="close">&times;</b>
        </div>
      </div>

      <!-- SEARCH / ADD RECIPIENT -->
      <div ng-hide="$ctrl.state">
        <input type="text" id="recipientSearch" placeholder="S&oslash;k i kundeliste" ng-model="$ctrl.recipient.name" ng-keydown="$ctrl.actions($event)" autocomplete="off">

        <div class="scroll-content recipientWidgetResult" ng-show="$ctrl.recipients.length">
          <div class="clearfix inner">
            <a href id="recipient_{{ $index }}" ng-click="$ctrl.load(recipient.number)" ng-repeat="recipient in $ctrl.recipients" ng-class="{ selected: recipient.selected }">
              <span>{{ recipient.name }}</span>
              <span class="label secondary right" ng-show="recipient.customerNumber">{{ recipient.customerNumber }}</span>
            </a>

            <div class="warning" ng-show="$ctrl.total >= $ctrl.limit">For mange treff, skriv mer av navnet</div>
          </div>
        </div>

        <a href role="button" class="button" ng-hide="$ctrl.allownew==='n'" ng-click="$ctrl.createNew($ctrl.recipient.name)">Registrer ny kunde <em>{{ $ctrl.recipient.name }}</em></a>
      </div>

      <!-- VIEW / CREATE FORM -->
      <div class="row" ng-show="$ctrl.state" ng-form name="newRecipientForm">
        <div class="large-12 columns">

          <!-- Customer number -->
          <div>
            <label for="recipientNo" data-balloon-length="large" data-balloon="Skriv inn kundenummer for automatisk oppslag mot kundelisten. Hvis det allerede står et kundenummer der, er det ditt neste ledige kundenummer som er automatisk foreslått av systemet. Hvis det ikke blir foreslått noe kundenummer, er det fordi du ikke har noen registrerte kunder med kundenummer bestående av bare tall.">
              {{ $ctrl.getLabel('NUMBER') }}
              <i class="fa fa-question-circle"></i>
            </label>
            <input type="text" id="recipientNo" ng-disabled="$ctrl.recipient.number" ng-model="$ctrl.recipient.customerNumber" ng-blur="$ctrl.broadcast()" maxlength="32" autocomplete="off">
          </div>

          <!-- Name -->
          <div>
            <label for="recipientName">{{ $ctrl.getLabel('NAME') }}</label>
            <input type="text" maxlength="64" id="recipientName" name="recipient.name" ng-disabled="$ctrl.recipient.number" ng-model="$ctrl.recipient.name" ng-blur="$ctrl.broadcast()" autocomplete="off" placeholder="Ola Nordmann" required>
            <span class="error" ng-show="newRecipientForm['recipient.name'].$dirty && newRecipientForm['recipient.name'].$invalid">Ugyldig navn</span>

            <brreg-lookup ng-hide="!$ctrl.showBrreg || $ctrl.recipient.number" q="$ctrl.recipient.name"></brreg-lookup>

            <div ng-show="$ctrl.recipients.length && !$ctrl.recipient.number">
              <label class="inline">
                Mente du denne kunden?
              </label>

              <div class="scroll-content recipientWidgetResult">
                <div class="clearfix inner">
                  <a href ng-click="$ctrl.load(recipient.number)" ng-repeat="recipient in $ctrl.recipients">
                    <span>{{ recipient.name }}</span>
                    <span class="label secondary right" ng-show="recipient.customerNumber">{{ recipient.customerNumber }}</span>
                  </a>

                  <div class="warning" ng-show="$ctrl.total >= $ctrl.limit">For mange treff, skriv mer av navnet</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Organisation number -->
          <div>
            <label for="recipientOrgNo" data-balloon-length="large" data-balloon="Vises ikke på regningen. Feltet brukes kun som adresse for EHF-regninger. Oppgi et norsk eller svensk organisasjonsnummer, eller et GLN-nummer for mottagere i øvrige land.">
              {{ $ctrl.getLabel('ORGNO') }}
              <i class="fa fa-question-circle"></i>
            </label>
              <div class="small-4 columns">
                  <select id="icd" name="icd" ng-change="$ctrl.recipient.organisationNumber = ''" ng-model="$ctrl.recipient.organisation.icd" ng-disabled="$ctrl.recipient.organisation.number || $ctrl.locked">
                    <option value="9908" ng-selected="$ctrl.recipient.icd === '9908'">Norsk</option>
                    <option value="0007" ng-selected="$ctrl.recipient.icd === '0007'">Svensk</option>
                    <option value="0088" ng-selected="$ctrl.recipient.icd === '0088'">Internasjonalt (GLN)</option>
                  </select>
              </div>

              <div class="small-8 columns">
                <!--              <input type="hidden" id="icd" name="icd" ng-model="$ctrl.recipient.organisation.icd">-->

                <input type="text" id="recipientOrgNo" name="organisationNumber" ng-disabled="$ctrl.recipient.organisation.number || $ctrl.locked" ng-model="$ctrl.recipient.organisationNumber" placeholder="123 456 789" ng-blur="$ctrl.broadcast()" recipient-organisation-number-validator>
<!--                <input type="text" id="recipientOrgNo" name="organisationNumber" ng-disabled="$ctrl.recipient.organisation.number || $ctrl.locked" ng-model="$ctrl.recipient.organisationNumber" placeholder="123 456 789" ng-blur="$ctrl.broadcast()" organisation-number-validator>-->
                <span class="error" ng-show="newRecipientForm.organisationNumber.$invalid">Vennligst fyll inn et gyldig organisasjonsnummer. Et organisasjonsnummer har disse gyldige formatene: 123456789 eller 123 456 789 (norsk) / 1234567890 eller 123456-7890 (svensk)</span>
              </div>

          </div>

          <!-- Address -->
          <div>
            <label for="recipientAddress1">{{ $ctrl.getLabel('ADDRESS') }}</label>
            <input type="text" id="recipientAddress1" ng-model="$ctrl.recipient.contact.address.address1" maxlength="42" ng-blur="$ctrl.broadcast()" ng-disabled="$ctrl.recipient.number">
            <input type="text" id="recipientAddress2" ng-model="$ctrl.recipient.contact.address.address2" maxlength="42" ng-blur="$ctrl.broadcast()" ng-disabled="$ctrl.recipient.number">
          </div>

          <!-- Zip & City -->
          <div class="row">
            <div class="large-5 columns">
              <label for="recipientZip">{{ $ctrl.getLabel('ZIP') }}</label>
              <input autocomplete="off" type="text" id="recipientZip" name="recipient.address.zip" ng-disabled="$ctrl.recipient.number" ng-model="$ctrl.recipient.contact.address.zip" ng-change="$ctrl.getCityByZip()" ng-blur="$ctrl.broadcast()" maxlength="8" placeholder="0124" required>
              <span class="error" ng-show="newRecipientForm['recipient.address.zip'].$dirty && newRecipientForm['recipient.address.zip'].$invalid">Ugyldig postnummer</span>
            </div>
            <div class="large-7 columns">
              <label for="recipientCity">{{ $ctrl.getLabel('CITY') }}</label>
              <input type="text" id="recipientCity" name="recipient.address.city" ng-disabled="$ctrl.recipient.number" ng-model="$ctrl.recipient.contact.address.city" ng-blur="$ctrl.broadcast()" placeholder="OSLO" required>
              <span class="error" ng-show="newRecipientForm['recipient.address.city'].$dirty && newRecipientForm['recipient.address.city'].$invalid">Ugyldig poststed</span>
            </div>
          </div>

          <!-- Country -->
          <div>
            <label for="recipientCountry">{{ $ctrl.getLabel('COUNTRY') }}</label>
            <select id="recipientCountry" ng-model="$ctrl.recipient.contact.address.country" ng-options="country for country in $ctrl.countries" ng-blur="$ctrl.broadcast()" ng-disabled="$ctrl.recipient.number"></select>
          </div>

          <!-- E-mail -->
          <div>
            <label for="recipientEmail">{{ $ctrl.getLabel('EMAIL') }}</label>
<!--            <input type="email" mailcheck check-email-callback="$ctrl.broadcast()" name="recipient.contact.email" id="recipientEmail" ng-disabled="$ctrl.recipient.number" ng-model="$ctrl.recipient.contact.email" maxlength="64" placeholder="{{$ctrl.recipient.number ? '' : 'ola@nordmann.no'}}" ng-blur="$ctrl.broadcast()">-->
            <input type="email" mailcheck mailcheck-callback="$ctrl.broadcast()" name="recipient.contact.email" id="recipientEmail" ng-disabled="$ctrl.recipient.number" ng-model="$ctrl.recipient.contact.email" maxlength="64" placeholder="{{$ctrl.recipient.number ? '' : 'ola@nordmann.no'}}" ng-blur="$ctrl.broadcast()">
            <span class="error" ng-show="newRecipientForm['recipient.contact.email'].$dirty && newRecipientForm['recipient.contact.email'].$invalid">Vennligst oppgi en gyldig e-postadresse</span>
          </div>

          <div>
            <label for="mobile" data-balloon-length="large" data-balloon="For utenlandske mobilnumre, bruk +(landkode) eller 00(landkode), f. eks. +48 eller 0048, foran telefonnummeret.">{{ $ctrl.getLabel('MOBILE') }}
                <i class="fa fa-question-circle"></i>
            </label>
            <input type="tel" name="recipient.contact.mobile" id="recipientMobile" ng-disabled="$ctrl.recipient.number" ng-model="$ctrl.recipient.contact.mobile" ng-blur="$ctrl.broadcast()" international-mobile-number-validator>
<!--            <span class="error" ng-show="newRecipientForm['recipient.contact.mobile'].$dirty && newRecipientForm['recipient.contact.mobile'].$invalid">Vennligst oppgi en gyldig mobilnummer</span>-->
          </div>

          <fieldset ng-show="!$ctrl.recipient.number">
            <div ng-show="$ctrl.availableLabels.length() || $ctrl.selectedLabels.length()">
              <h3 class="subheader">Valgte grupper</h3>

              <select ng-show="$ctrl.availableLabels.length()" id="recipientLabels" name="recipientLabels" ng-model="$ctrl.selectedLabel" ng-options="label as label.name for label in $ctrl.availableLabels.get() | orderBy:'name'" ng-change="$ctrl.selectLabel($ctrl.selectedLabel)">
                <option value="">Meld inn i gruppe</option>
              </select>
              <div>
                <span class="label success" ng-repeat="label in $ctrl.selectedLabels.get()" style="margin: 3px;">
                  {{ label.name }}
                  <span class="close" ng-click="$ctrl.deselectLabel(label)">&times;</span>
                </span>
              </div>

              <hr>
            </div>

            <h3 class="subheader">Legg til i ny gruppe</h3>

            <input type="text" id="labelName" name="labelName" ng-model="$ctrl.newLabel" placeholder="Bedrift">

            <button type="button" class="button small secondary" ng-disabled="!$ctrl.newLabel" ng-click="$ctrl.addLabel()">Legg til {{ $ctrl.newLabel }}</button>
          </fieldset>
        </div>
      </div>

    </fieldset>
  `
};

angular
  .module('SendRegning')
  .component('recipientPicker', recipientPicker);
